document.addEventListener('click', function(e){
    var link = e.target.closest('.product-info__description .prose .read-more a');
    if (!link) return;

    e.preventDefault();
    var target = document.querySelector('.anchor-text');
    if (target) {
        window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 50, behavior: 'smooth' });
    }
    return false;
});